module.exports = __webpack_public_path__ + "static/media/treasurer.2806bbad.jpg";